export const GENDERS = ["Woman", "Man", "Non-binary", "Trans woman", "Trans man", "Genderfluid"];
export const ORIENTATIONS = ["Straight", "Gay", "Bisexual", "Pansexual", "Queer", "Curious"];
export const GOALS = ["Casual", "One-night", "Long-term", "Discreet", "Role-play"];
export const KINKS = [
  "Dominance", "Submission", "Bondage", "Sensory play", "Voyeurism",
  "Exhibitionism", "Role-play", "Leather", "Impact play", "Shibari",
];
export const MARQUEE = [
  "Discretion", "Role-play", "Dominance", "Submission", "Sensory play",
  "Long-term", "One-night", "Bondage", "Consent", "Fantasy", "Voyeurism",
];
